import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RetailService { 

    constructor(private http: HttpClient) { }

    getretailService() {
        return this.http.get<any[]>(`${environment.apiUrl}get_retail`);
    }    	    
}
